// movies.js
export const featuredMovies = [
  {
    id: 1,
    title: "El Épico Blockbuster",
    description: "Una aventura que te dejará sin aliento, fusionando acción y misterio como nunca.",
    image: "https://images.unsplash.com/photo-1506905925346-21bda4d32df4?ixlib=rb-4.0.3&auto=format&fit=crop&w=2071&q=80",
    genres: ["Acción", "Aventura"],
    rating: 8.5,
    duration: "2h 45m",
    videoSrc: "https://www.w3schools.com/html/mov_bbb.mp4"
  },
  {
    id: 2,
    title: "Cielos de Fuego",
    description: "Una épica batalla aérea que redefine los límites de la cinematografía moderna.",
    image: "https://images.unsplash.com/photo-1534447677768-be436bb09401?ixlib=rb-4.0.3&auto=format&fit=crop&w=2094&q=80",
    genres: ["Acción", "Drama"],
    rating: 8.2,
    duration: "2h 18m",
    videoSrc: "https://www.w3schools.com/html/mov_bbb.mp4"
  },
  {
    id: 3,
    title: "El Último Horizonte",
    description: "Un viaje interestelar que desafía la realidad y explora los confines del universo.",
    image: "https://images.unsplash.com/photo-1446776653964-20c1d3a81b06?ixlib=rb-4.0.3&auto=format&fit=crop&w=2071&q=80",
    genres: ["Ciencia Ficción", "Aventura"],
    rating: 9.1,
    duration: "2h 52m",
    videoSrc: "https://www.w3schools.com/html/mov_bbb.mp4"
  },
  {
    id: 4,
    title: "Sombras en la Ciudad",
    description: "Un thriller psicológico que te mantendrá al borde del asiento hasta el último minuto.",
    image: "https://images.unsplash.com/photo-1489599809505-f2d4c3f17702?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80",
    genres: ["Suspenso", "Thriller"],
    rating: 8.7,
    duration: "1h 58m",
    videoSrc: "https://www.w3schools.com/html/mov_bbb.mp4"
  },
  {
    id: 5,
    title: "Risas Sin Parar",
    description: "Una comedia hilarante que redefine el género con situaciones absurdamente divertidas.",
    image: "https://images.unsplash.com/photo-1489599809505-f2d4c3f17702?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80",
    genres: ["Comedia"],
    rating: 7.9,
    duration: "1h 45m",
    videoSrc: "https://www.w3schools.com/html/mov_bbb.mp4"
  },
  {
    id: 6,
    title: "El Legado Perdido",
    description: "Una búsqueda ancestral que revela secretos familiares ocultos por generaciones.",
    image: "https://images.unsplash.com/photo-1534447677768-be436bb09401?ixlib=rb-4.0.3&auto=format&fit=crop&w=2094&q=80",
    genres: ["Drama", "Misterio"],
    rating: 8.8,
    duration: "2h 25m",
    videoSrc: "https://www.w3schools.com/html/mov_bbb.mp4"
  }
];

// Agregar featuredMovie de nuevo para compatibilidad
export const featuredMovie = featuredMovies[0];

export const categories = {
  action: [
    {
      id: 1,
      title: "Furia Máxima",
      description: "Un ex militar debe rescatar a su familia de un grupo de terroristas en un rascacielos de lujo.",
      image: "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80",
      genres: ["Acción", "Suspenso"],
      rating: 7.8,
      duration: "1h 58m",
      year: 2023,
      videoSrc: "https://www.w3schools.com/html/mov_bbb.mp4"
    },
    {
      id: 2,
      title: "Guerra Estelar",
      description: "Una batalla épica interestelar que decidirá el destino de la galaxia.",
      image: "https://images.unsplash.com/photo-1441974231531-c6227db76b6e?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80",
      genres: ["Acción", "Ciencia Ficción"],
      rating: 8.2,
      duration: "2h 15m",
      year: 2024,
      videoSrc: "https://www.w3schools.com/html/mov_bbb.mp4"
    },
    {
      id: 3,
      title: "Cazador Nocturno",
      description: "Un detective obsesionado persigue a un asesino en serie en las calles de la ciudad.",
      image: "https://images.unsplash.com/photo-1571171638497-7f375a5c87ea?ixlib=rb-4.0.3&auto=format&fit=crop&w=2071&q=80",
      genres: ["Acción", "Thriller"],
      rating: 7.5,
      duration: "2h 05m",
      year: 2023,
      videoSrc: "https://www.w3schools.com/html/mov_bbb.mp4"
    },
    {
      id: 4,
      title: "Explosión Total",
      description: "Un equipo de élite debe desactivar una bomba en el metro de la ciudad.",
      image: "https://images.unsplash.com/photo-1506905925346-21bda4d32df4?ixlib=rb-4.0.3&auto=format&fit=crop&w=2071&q=80",
      genres: ["Acción", "Aventura"],
      rating: 8.0,
      duration: "1h 52m",
      year: 2024,
      videoSrc: "https://www.w3schools.com/html/mov_bbb.mp4"
    },
    {
      id: 5,
      title: "Operación Rescate",
      description: "Misión secreta para rescatar a rehenes en una embajada extranjera.",
      image: "https://images.unsplash.com/photo-1489599809505-c2c4c1f8030a?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80",
      genres: ["Acción", "Drama"],
      rating: 7.9,
      duration: "2h 10m",
      year: 2023,
      videoSrc: "https://www.w3schools.com/html/mov_bbb.mp4"
    }
  ],
  comedy: [
    {
      id: 6,
      title: "Risas Locas",
      description: "Un grupo de amigos vive situaciones hilarantes durante unas vacaciones en la playa.",
      image: "https://images.unsplash.com/photo-1578898888364-f71d907def97?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80",
      genres: ["Comedia", "Aventura"],
      rating: 7.2,
      duration: "1h 45m",
      year: 2023,
      videoSrc: "https://www.w3schools.com/html/mov_bbb.mp4"
    },
    {
      id: 7,
      title: "Caos Familiar",
      description: "La reunión familiar más divertida y caótica que puedas imaginar.",
      image: "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80",
      genres: ["Comedia", "Familiar"],
      rating: 7.9,
      duration: "1h 55m",
      year: 2024,
      videoSrc: "https://www.w3schools.com/html/mov_bbb.mp4"
    },
    {
      id: 8,
      title: "Broma Épica",
      description: "Una broma universitaria sale terriblemente mal... o terriblemente bien.",
      image: "https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80",
      genres: ["Comedia", "Juvenil"],
      rating: 6.8,
      duration: "1h 40m",
      year: 2023,
      videoSrc: "https://www.w3schools.com/html/mov_bbb.mp4"
    },
    {
      id: 9,
      title: "Diversión Pura",
      description: "Un día en la vida de tres mejores amigos que buscan diversión a cualquier costo.",
      image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80",
      genres: ["Comedia", "Road Movie"],
      rating: 7.4,
      duration: "1h 50m",
      year: 2024,
      videoSrc: "https://www.w3schools.com/html/mov_bbb.mp4"
    },
    {
      id: 10,
      title: "Amigos por Siempre",
      description: "La historia de amistad más divertida que cambiará sus vidas para siempre.",
      image: "https://images.unsplash.com/photo-1511795409834-ef04bbd61622?ixlib=rb-4.0.3&auto=format&fit=crop&w=2069&q=80",
      genres: ["Comedia", "Drama"],
      rating: 8.1,
      duration: "2h 05m",
      year: 2023,
      videoSrc: "https://www.w3schools.com/html/mov_bbb.mp4"
    }
  ],
  drama: [
    {
      id: 11,
      title: "Corazón Roto",
      description: "Una historia de amor imposible que desafía todas las convenciones sociales.",
      image: "https://images.unsplash.com/photo-1517457373958-b7bdd4587206?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80",
      genres: ["Drama", "Romance"],
      rating: 8.7,
      duration: "2h 20m",
      year: 2024,
      videoSrc: "https://www.w3schools.com/html/mov_bbb.mp4"
    },
    {
      id: 12,
      title: "Vidas Cruzadas",
      description: "Destinos que se entrelazan en la gran ciudad de manera inesperada.",
      image: "https://images.unsplash.com/photo-1481627834876-b7833e8f5570?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80",
      genres: ["Drama", "Suspenso"],
      rating: 8.1,
      duration: "2h 15m",
      year: 2023,
      videoSrc: "https://www.w3schools.com/html/mov_bbb.mp4"
    },
    {
      id: 13,
      title: "Sombras del Pasado",
      description: "Secretos familiares resurgen para cambiar el presente de manera irreversible.",
      image: "https://images.unsplash.com/photo-1462331940025-496dfbfc7564?ixlib=rb-4.0.3&auto=format&fit=crop&w=2071&q=80",
      genres: ["Drama", "Misterio"],
      rating: 8.4,
      duration: "2h 10m",
      year: 2024,
      videoSrc: "https://www.w3schools.com/html/mov_bbb.mp4"
    },
    {
      id: 14,
      title: "Sueños Rotos",
      description: "La lucha por alcanzar los sueños en un mundo lleno de obstáculos.",
      image: "https://images.unsplash.com/photo-1489598982807-2f9b7589c2b5?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80",
      genres: ["Drama", "Inspirador"],
      rating: 7.6,
      duration: "2h 05m",
      year: 2023,
      videoSrc: "https://www.w3schools.com/html/mov_bbb.mp4"
    },
    {
      id: 15,
      title: "El Legado Perdido",
      description: "Una búsqueda ancestral que revela secretos familiares ocultos por generaciones.",
      image: "https://images.unsplash.com/photo-1534447677768-be436bb09401?ixlib=rb-4.0.3&auto=format&fit=crop&w=2094&q=80",
      genres: ["Drama", "Misterio"],
      rating: 8.8,
      duration: "2h 25m",
      year: 2024,
      videoSrc: "https://www.w3schools.com/html/mov_bbb.mp4"
    }
  ],
  romance: [
    {
      id: 16,
      title: "Amor en París",
      description: "Un encuentro casual en la ciudad del amor que cambiará dos vidas para siempre.",
      image: "https://images.unsplash.com/photo-1502602898536-47ad22581b52?ixlib=rb-4.0.3&auto=format&fit=crop&w=2069&q=80",
      genres: ["Romance", "Drama"],
      rating: 8.3,
      duration: "1h 58m",
      year: 2024,
      videoSrc: "https://www.w3schools.com/html/mov_bbb.mp4"
    },
    {
      id: 17,
      title: "Bajo la Misma Estrella",
      description: "Dos almas destinadas a encontrarse bajo el cielo estrellado.",
      image: "https://images.unsplash.com/photo-1534447677768-be436bb09401?ixlib=rb-4.0.3&auto=format&fit=crop&w=2094&q=80",
      genres: ["Romance", "Drama"],
      rating: 8.5,
      duration: "2h 12m",
      year: 2023,
      videoSrc: "https://www.w3schools.com/html/mov_bbb.mp4"
    }
  ],
  sciFi: [
    {
      id: 18,
      title: "Odisea Espacial",
      description: "Viaje interestelar hacia lo desconocido en busca de un nuevo hogar para la humanidad.",
      image: "https://images.unsplash.com/photo-1446776653964-20c1d3a81b06?ixlib=rb-4.0.3&auto=format&fit=crop&w=2071&q=80",
      genres: ["Ciencia Ficción", "Aventura"],
      rating: 8.6,
      duration: "2h 30m",
      year: 2024,
      videoSrc: "https://www.w3schools.com/html/mov_bbb.mp4"
    },
    {
      id: 19,
      title: "Futuro Incierto",
      description: "Una distopía donde la tecnología controla cada aspecto de la vida humana.",
      image: "https://images.unsplash.com/photo-1451187580459-43490279c0fa?ixlib=rb-4.0.3&auto=format&fit=crop&w=2072&q=80",
      genres: ["Ciencia Ficción", "Thriller"],
      rating: 8.2,
      duration: "2h 18m",
      year: 2023,
      videoSrc: "https://www.w3schools.com/html/mov_bbb.mp4"
    }
  ],
  horror: [
    {
      id: 20,
      title: "La Casa del Miedo",
      description: "Una familia descubre que su nueva casa esconde terribles secretos sobrenaturales.",
      image: "https://images.unsplash.com/photo-1509248961154-692f6d1b73ac?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80",
      genres: ["Terror", "Suspenso"],
      rating: 7.4,
      duration: "1h 52m",
      year: 2024,
      videoSrc: "https://www.w3schools.com/html/mov_bbb.mp4"
    },
    {
      id: 21,
      title: "Susurros en la Oscuridad",
      description: "Voces del más allá amenazan con revelar oscuros secretos familiares.",
      image: "https://images.unsplash.com/photo-1482160549825-59d7b92c8fe4?ixlib=rb-4.0.3&auto=format&fit=crop&w=2069&q=80",
      genres: ["Terror", "Misterio"],
      rating: 7.8,
      duration: "1h 58m",
      year: 2023,
      videoSrc: "https://www.w3schools.com/html/mov_bbb.mp4"
    }
  ]
};


// Sistema de progreso de visualización
export const getWatchProgress = (movieId) => {
  if (typeof window === 'undefined') return 0;
  const progress = localStorage.getItem(`movie_progress_${movieId}`);
  return progress ? parseInt(progress) : 0;
};

export const saveWatchProgress = (movieId, progress) => {
  if (typeof window === 'undefined') return;
  localStorage.setItem(`movie_progress_${movieId}`, progress.toString());
};

export const getContinueWatching = () => {
  if (typeof window === 'undefined') return [];
  
  const allMovies = Object.values(categories).flat();
  return allMovies.filter(movie => {
    const progress = getWatchProgress(movie.id);
    return progress > 0 && progress < 95; // No mostrar completadas al 95%+
  }).sort((a, b) => {
    // Ordenar por último visto (usando timestamp si lo guardas)
    const timeA = localStorage.getItem(`movie_time_${a.id}`) || 0;
    const timeB = localStorage.getItem(`movie_time_${b.id}`) || 0;
    return timeB - timeA;
  });
};